/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Hide_ClosedInputs */

const cs_deals_hide_closed = /** @type {(inputs: Deals_Hide_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrýt výhru / prohru`)
};

const en_deals_hide_closed = /** @type {(inputs: Deals_Hide_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide won / lost`)
};

/**
* | output |
* | --- |
* | "Hide won / lost" |
*
* @param {Deals_Hide_ClosedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_hide_closed = /** @type {((inputs?: Deals_Hide_ClosedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Hide_ClosedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_hide_closed(inputs)
	return cs_deals_hide_closed(inputs)
});